import { render, staticRenderFns } from "./request-new.vue?vue&type=template&id=ea8a5b48&"
import script from "./request-new.vue?vue&type=script&lang=js&"
export * from "./request-new.vue?vue&type=script&lang=js&"
import style0 from "./request-new.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports